/**
 * @generated SignedSource<<0b648ef255317c520cf1468eec54a858>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type answersStatisticsTable_Refetch$variables = {
  after?: string | null | undefined;
  filterByTagIds?: ReadonlyArray<string> | null | undefined;
  filterByTitle?: string | null | undefined;
  first?: number | null | undefined;
  greaterThanDate?: string | null | undefined;
  lessThanDate?: string | null | undefined;
};
export type answersStatisticsTable_Refetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"answersStatisticsTable_Fragment">;
};
export type answersStatisticsTable_Refetch = {
  response: answersStatisticsTable_Refetch$data;
  variables: answersStatisticsTable_Refetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByTagIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByTitle"
  },
  {
    "defaultValue": 1,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "greaterThanDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lessThanDate"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filterByTagIds",
    "variableName": "filterByTagIds"
  },
  {
    "kind": "Variable",
    "name": "filterByTitle",
    "variableName": "filterByTitle"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "greaterThanDate",
    "variableName": "greaterThanDate"
  },
  {
    "kind": "Variable",
    "name": "lessThanDate",
    "variableName": "lessThanDate"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "answersStatisticsTable_Refetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "answersStatisticsTable_Fragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "answersStatisticsTable_Refetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StatisticAdminSchema",
            "kind": "LinkedField",
            "name": "Statistic",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "NodeQuestionAndAnswersTriesConnection",
                "kind": "LinkedField",
                "name": "AnswersStatistic",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NodeQuestionAndAnswersTriesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NodeQuestionAndAnswersTries",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rootNodeId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rootNodeTitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ElementStatistics",
                            "kind": "LinkedField",
                            "name": "elementStatistics",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "elementId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "question",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalTries",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "correctPercentage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerStatistics",
                                "kind": "LinkedField",
                                "name": "answerStatistics",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "checkedTimes",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "index",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isCorrect",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "filterByTitle",
                  "greaterThanDate",
                  "lessThanDate",
                  "filterByTagIds"
                ],
                "handle": "connection",
                "key": "answersStatisticsTable_AnswersStatistic",
                "kind": "LinkedHandle",
                "name": "AnswersStatistic"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "da045cf8285b0bb70a604dc6e26e13c8",
    "id": null,
    "metadata": {},
    "name": "answersStatisticsTable_Refetch",
    "operationKind": "query",
    "text": "query answersStatisticsTable_Refetch(\n  $after: String\n  $filterByTagIds: [ID!]\n  $filterByTitle: String\n  $first: Int = 1\n  $greaterThanDate: ZonedDateTIme\n  $lessThanDate: ZonedDateTIme\n) {\n  ...answersStatisticsTable_Fragment_hSDSH\n}\n\nfragment answersStatisticsTable_Fragment_hSDSH on Query {\n  Admin {\n    Statistic {\n      AnswersStatistic(first: $first, after: $after, filterByTitle: $filterByTitle, greaterThanDate: $greaterThanDate, lessThanDate: $lessThanDate, filterByTagIds: $filterByTagIds) {\n        edges {\n          node {\n            rootNodeId\n            rootNodeTitle\n            elementStatistics {\n              elementId\n              question\n              totalTries\n              correctPercentage\n              answerStatistics {\n                checkedTimes\n                index\n                isCorrect\n              }\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "28d580dbca95b87b86f6c73686ea4a55";

export default node;
